import { useRef } from "react";
import { NavLink } from "react-router";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";

import Logo from "../assets/images/Logo.svg";

const Header = () => {
  const timeoutDuration = 120;

  const triggerRef = useRef<HTMLButtonElement | null>(null);
  const timeOutRef = useRef(timeoutDuration);

  const handleEnter = (isOpen: boolean) => {
    clearTimeout(timeOutRef.current);
    !isOpen && triggerRef.current?.click();
  };

  const handleLeave = (isOpen: boolean) => {
    timeOutRef.current = setTimeout(() => {
      isOpen && triggerRef.current?.click();
    }, timeoutDuration);
  };

  return (
    <>
      <header className="bg-white p-4">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between px-8 text-xl font-bold xs:flex-row">
          <img
            src={Logo}
            alt="Provido"
            width={200}
            fetchPriority="high"
            rel="preload"
          />

          <nav className="mx-8 hidden flex-row gap-8 text-darkblue lg:flex">
            <NavLink to="/" title="Home">
              Home
            </NavLink>
            <NavLink to="/about" title="About">
              About
            </NavLink>
            <Menu>
              {({ open }) => (
                <div
                  onMouseEnter={() => handleEnter(open)}
                  onMouseLeave={() => handleLeave(open)}
                >
                  <MenuButton
                    className="menu-button flex flex-row items-center gap-1 focus:outline-0"
                    title="Services"
                    ref={triggerRef}
                  >
                    Services
                    <span className="ph ph-[caret-down]"></span>
                  </MenuButton>
                  <MenuItems
                    anchor="bottom"
                    className="mt-4 flex w-fit flex-col rounded-4xl bg-blue p-6 pb-2 focus:outline-0"
                  >
                    <MenuItem>
                      <NavLink
                        to="/services/support-with-daily-living"
                        title="Support with Daily Living"
                        className="menu-link"
                      >
                        Support with Daily Living
                      </NavLink>
                    </MenuItem>
                    <MenuItem>
                      <NavLink
                        to="/services/community-access"
                        title="Community Access"
                        className="menu-link"
                      >
                        Community Access
                      </NavLink>
                    </MenuItem>
                    <MenuItem>
                      <NavLink
                        to="/services/nursing"
                        title="Nursing"
                        className="menu-link"
                      >
                        Nursing
                      </NavLink>
                    </MenuItem>
                    <MenuItem>
                      <NavLink
                        to="/services/transport"
                        title="Transport"
                        className="menu-link"
                      >
                        Transport
                      </NavLink>
                    </MenuItem>
                    <MenuItem>
                      <NavLink
                        to="/services/exercise-physiology"
                        title="Exercise Physiology"
                        className="menu-link"
                      >
                        Exercise Physiology
                      </NavLink>
                    </MenuItem>
                    <MenuItem>
                      <NavLink
                        to="/services/supported-independent-living"
                        title="Supported Independent Living"
                        className="menu-link"
                      >
                        Supported Independent Living
                      </NavLink>
                    </MenuItem>
                  </MenuItems>
                </div>
              )}
            </Menu>
            <NavLink to="/contact" title="Contact">
              Contact
            </NavLink>
          </nav>

          <a
            href="tel:0348319551"
            className="mt-4 rounded-full bg-blue px-4 py-2 text-white hover:bg-purple xs:m-0"
            title="Call Provido"
          >
            03 4831 9551
          </a>
        </div>
      </header>

      {/* Mobile Navigation */}
      <div className="bg-white p-2 text-center font-display text-purple lg:hidden">
        <Disclosure>
          <DisclosureButton
            className="flex w-full flex-row items-center justify-center gap-1 text-xl"
            title="Menu"
          >
            <span className="ph h-6 w-6 ph-[list--bold]"></span> Menu
          </DisclosureButton>
          <DisclosurePanel className="flex flex-col gap-4 py-4 text-lg text-blue">
            <DisclosureButton as="a" href="/" title="Home page">
              Home
            </DisclosureButton>
            <DisclosureButton as="a" href="/about" title="About">
              About
            </DisclosureButton>
            <Disclosure>
              <DisclosureButton
                title="Services"
                className="ml-6 flex flex-row items-center justify-center gap-1"
              >
                Services
                <span className="ph ph-[caret-down]"></span>
              </DisclosureButton>
              <DisclosurePanel className="flex flex-col gap-4 rounded-4xl bg-blue py-4 text-white">
                <DisclosureButton
                  as="a"
                  href="/services/support-with-daily-living"
                  title="Support with Daily Living"
                >
                  Support with Daily Living
                </DisclosureButton>
                <DisclosureButton
                  as="a"
                  href="/services/community-access"
                  title="Community Access"
                >
                  Community Access
                </DisclosureButton>
                <DisclosureButton
                  as="a"
                  href="/services/nursing"
                  title="Nursing"
                >
                  Nursing
                </DisclosureButton>
                <DisclosureButton
                  as="a"
                  href="/services/transport"
                  title="Transport"
                >
                  Transport
                </DisclosureButton>
                <DisclosureButton
                  as="a"
                  href="/services/exercise-physiology"
                  title="Exercise Physiology"
                >
                  Exercise Physiology
                </DisclosureButton>
                <DisclosureButton
                  as="a"
                  href="/services/supported-independent-living"
                  title="Supported Independent Living"
                >
                  Supported Independent Living
                </DisclosureButton>
              </DisclosurePanel>
            </Disclosure>
            <DisclosureButton as="a" href="/contact" title="Contact">
              Contact
            </DisclosureButton>
          </DisclosurePanel>
        </Disclosure>
      </div>
    </>
  );
};

export default Header;
